"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const i18next_1 = __importDefault(require("i18next"));
const functions_1 = require("@/common/functions");
function default_1(props) {
    const { confirm, whoAmI, paymentApprovalCd } = props;
    const isParentalConsent = paymentApprovalCd === 'ROOM_PAY_APPROVAL_STATUS_00';
    const isCertifiedRequired = paymentApprovalCd === 'ROOM_PAY_APPROVAL_STATUS_01';
    const isAdultOnly = paymentApprovalCd === 'ROOM_PAY_APPROVAL_STATUS_02';
    const isUnder14 = paymentApprovalCd === 'ROOM_PAY_APPROVAL_STATUS_04';
    const isAgentAgree = whoAmI.agent_agree;
    const isUserCertified = whoAmI.is_certified;
    const isUserUnder19 = whoAmI.is_under_19;
    const isUserUnder14 = whoAmI.is_under_14;
    const confirmOptions = { allowClose: false };
    const description = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('작가님 요청으로'), (0, jsx_runtime_1.jsx)("br", {}), isParentalConsent && i18next_1.default.t('본인인증 및 법정대리인 동의를 받은 회원만 참여할 수 있어요.'), isCertifiedRequired && i18next_1.default.t('본인인증 회원만 참여할 수 있어요.'), isAdultOnly && i18next_1.default.t('19세 이상 성인만 참여할 수 있어요.'), isUnder14 && i18next_1.default.t('만 14세 이상 회원만 참여할 수 있어요.')] }));
    Object.assign(confirmOptions, { description });
    const isAdultOnlyAndUserCertifiedUnder19 = isAdultOnly && isUserCertified && isUserUnder19;
    const isUnder14AndUserCertifiedUnder14 = isUnder14 && isUserCertified && isUserUnder14;
    if (!isAdultOnlyAndUserCertifiedUnder19 && !isUnder14AndUserCertifiedUnder14)
        Object.assign(confirmOptions, { confirmationText: i18next_1.default.t('본인인증') });
    if (isAdultOnlyAndUserCertifiedUnder19 || isUnder14AndUserCertifiedUnder14)
        Object.assign(confirmOptions, { cancellationButtonProps: { style: { display: 'none' } } });
    const isAdultOnlyAndUserNotCertified = isAdultOnly && !isUserCertified;
    if (isAdultOnlyAndUserNotCertified)
        Object.assign(confirmOptions, { cancellationText: i18next_1.default.t('홈으로 이동') });
    const isParentalConsentAndUserNotCertifiedNorAgentAgree = isParentalConsent && !isUserCertified && !isAgentAgree;
    const onFulfilled = isAdultOnlyAndUserCertifiedUnder19
        ? functions_1.replaceToMain
        : isUnder14AndUserCertifiedUnder14
            ? () => { }
            : () => window.location.replace(`/member/setting${isParentalConsentAndUserNotCertifiedNorAgentAgree
                ? ''
                : `?from=${window.location.pathname}${window.location.search}`}`);
    const onRejected = isAdultOnlyAndUserNotCertified ? functions_1.replaceToMain : () => { };
    const isOrderBlocked = (isParentalConsent && !isUserCertified) ||
        (isParentalConsent && isUserCertified && isUserUnder19 && !isAgentAgree) ||
        (isCertifiedRequired && !isUserCertified) ||
        (isAdultOnly && isUserUnder19) ||
        (isUnder14 && isUserUnder14);
    if (isOrderBlocked) {
        confirm(confirmOptions).then(onFulfilled).catch(onRejected);
        return false;
    }
    else
        return true;
}
exports.default = default_1;
